module.exports = __webpack_public_path__ + "static/media/7.Braided hose pipe.b936473d.jpeg";